import { publicApi } from "@/lib/api";

const KEY = "dr_device_token";

export function getDeviceToken() {
  let token = localStorage.getItem(KEY);
  if (!token) {
    token =
      (crypto.randomUUID && crypto.randomUUID()) ||
      `dev_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(KEY, token);
  }
  return token;
}

export async function registerDevice(token, email) {
  return publicApi.registerDevice({ device_token: token, email: email || null });
}

export function todayUKDate() {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}
